import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { BaseExampleService, type BilingualExample } from '@/features/checking/domains/common/services/base-example-service';
import { HeaderServiceProxy } from '@/services/header-service-proxy';
import demoFile1Url from '@/assets/drafting/demo-files/EP2017879035 Annex to the communication.pdf?url';

export const ProsecutionExampleService = Symbol('ProsecutionExampleService');
export interface ProsecutionExampleService extends BaseExampleService {}

@injectable()
export class ProsecutionExampleServiceImpl extends BaseExampleService implements ProsecutionExampleService {
    constructor(
        @inject(HeaderServiceProxy)
        private headerServiceProxy: HeaderServiceProxy
    ) {
        super();
    }

    siteRegion() {
        return this.headerServiceProxy?.headerService?.account?.siteRegion;
    }

    getExamples() {
        if (!this.siteRegion()) {
            return [];
        }

        const examples = {
            CN: [
                {
                    text: 'CN201910180992.3',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: 'ec33cbdd-4487-4ae4-b177-a9ede2162879',
                        },
                        files: [],
                    },
                },
                {
                    text: 'US16/432491',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: 'd567d58a-2a31-4f45-b429-942fd5650f16',
                        },
                        files: [],
                    },
                },
                {
                    text: 'EP2017879035 Annex to the communication.pdf',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '7f03ee54-3c04-45d7-98a2-14dfd4da5b88',
                        },
                        files: [
                            { url: demoFile1Url, name: 'EP2017879035 Annex to the communication.pdf' }
                        ],
                    },
                }
            ],
            US: [
                {
                    text: 'US16/432491',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '0e595e61-cc35-43d0-a45e-0f208f05a6bd',
                        },
                        files: [],
                    },
                },
                {
                    text: 'CN201910180992.3',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '1da34a13-0ebd-4214-a301-b2bb9a199710',
                        },
                        files: [],
                    },
                },
                {
                    text: 'EP2017879035 Annex to the communication.pdf',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '19a4e20d-fe0a-4c78-ab05-94cefa1741cd',
                        },
                        files: [
                            { url: demoFile1Url, name: 'EP2017879035 Annex to the communication.pdf' }
                        ],
                    },
                }
            ],
            EU: [
                {
                    text: 'EP2017879035 Annex to the communication.pdf',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '7d828751-95d9-4624-bb9a-2e288a2fc2ea',
                        },
                        files: [
                            { url: demoFile1Url, name: 'EP2017879035 Annex to the communication.pdf' }
                        ],
                    },
                },
                {
                    text: 'CN201910180992.3',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '791fbcef-74de-44a5-8bef-6d06290e0bf3',
                        },
                        files: [],
                    },
                },
                {
                    text: 'US16/432491',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '9bab7495-2df6-4d6d-bb57-be4a101a1f3f',
                        },
                        files: [],
                    },
                }
            ],
        }

        return examples[this.siteRegion()!] || [];
    }

    protected getExamplesData(): BilingualExample[] {
        return [];
    }
}
